import { Menu as MenuMantine, Radio as RadioMantine } from '@mantine/core'
import styled from 'styled-components'

export const Menu = styled(MenuMantine)``

export const MenuDropdown = styled(Menu.Dropdown)`
  padding: 15px 5px !important;
  background-color: ${({ theme }) => theme.cor53} !important;
  border-width: 0.0625rem !important;
  border-style: solid !important;
  border-color: ${({ theme }) => theme.cor25} !important;
`

export const RadioGroup = styled(RadioMantine.Group)`
  display: grid;
  gap: 8px;
`

export const MenuItens = styled.div`
  padding: 10px !important;
`

export const DatePickerRadio = styled.div`
  gap: 8px;
  display: grid;
  width: 100%;
`
